import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Col, Row } from 'reactstrap';
import { InputFormField } from '../../../../components/InputFormField';
import { CandidateDto } from '../../../../services/applicant_tracking/CandidateService/CandidateDto';

interface PropTypes {
  formRegister: UseFormRegister<CandidateDto>;
}

export function CandidateCurrentPositionInput(props: PropTypes) {
  const required = false;

  return (
    <Row>
      <Col xs={3}>
        <InputFormField
          type={'text'}
          registerReturn={props.formRegister('company', {
            required: required,
          })}
          fieldName={'Current Company'}
          placeholder={'Insert Current Company'}
          isRequired={required}
          classNames={'fs-5'}
          headerClassNames={'fw-semibold'}
          disabled={false}
        />
      </Col>
      <Col xs={3}>
        <InputFormField
          type={'text'}
          registerReturn={props.formRegister('jobTitle', {
            required: required,
          })}
          fieldName={'Job Title'}
          placeholder={'Insert Job Title'}
          isRequired={required}
          classNames={'fs-5'}
          headerClassNames={'fw-semibold'}
          disabled={false}
        />
      </Col>
    </Row>
  );
}
